import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
export function SelectInput({ id, label, value, onChange, options, placeholder = 'Selecione...', className = 'brutal-select', }) {
    const handleChange = useCallback((e) => {
        onChange(e.target.value);
    }, [onChange]);
    const selectStyle = {
        width: '100%',
        maxWidth: '320px',
        backgroundColor: '#141414',
        border: '2px solid #333333',
        borderRadius: 0,
        color: '#f5f5f5',
        padding: '10px 14px',
        fontFamily: 'inherit',
        fontSize: '13px',
        cursor: 'pointer',
        transition: 'border-color 0.15s ease',
    };
    const labelStyle = {
        fontSize: '0.75rem',
        fontWeight: '600',
        color: '#999999',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: '0.375rem',
        display: 'block',
    };
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.375rem', maxWidth: '320px' }, children: [_jsx("label", { htmlFor: id, style: labelStyle, children: label }), _jsxs("select", { id: id, value: value, onChange: handleChange, style: selectStyle, children: [_jsx("option", { value: "", children: placeholder }), options.map(opt => (_jsx("option", { value: opt.value, children: opt.label }, opt.value)))] })] }));
}
